import { Link } from "react-router-dom";
import { Mail, Heart, Instagram } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-3 mb-4">
              <img
                src="https://izkyvqbleuatzitwmtjw.supabase.co/storage/v1/object/public/pics2/Black%20Camera%20Icon%20Photography%20Logo%20(3).png"
                alt="MySabbat"
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-primary-foreground/70 text-sm leading-relaxed">
              Din guide til det perfekte sabbatår. Job, rejser, højskole og planlægning — samlet i én app.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="font-semibold text-sm uppercase tracking-wider mb-4 text-primary-foreground/90">Produkt</h3>
            <ul className="space-y-2.5">
              <li><a href="/#features" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">Features</a></li>
              <li><Link to="/waitlist" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">Hent appen</Link></li>
              <li><Link to="/om-os" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">Om os</Link></li>
              <li><Link to="/kontakt" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">Kontakt</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-sm uppercase tracking-wider mb-4 text-primary-foreground/90">Juridisk</h3>
            <ul className="space-y-2.5">
              <li><Link to="/privacy" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">Terms of Use</Link></li>
              <li><Link to="/slet-konto" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">Slet konto</Link></li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="font-semibold text-sm uppercase tracking-wider mb-4 text-primary-foreground/90">Følg os</h3>
            <div className="flex items-center gap-3 mb-6">
              <a href="https://instagram.com/mysabbat.dk" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-primary-foreground/20 transition-colors" aria-label="Instagram">
                <Instagram className="w-4 h-4 text-primary-foreground" />
              </a>
              <a href="https://tiktok.com/@mysabbat.dk" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-primary-foreground/20 transition-colors" aria-label="TikTok">
                <svg className="w-4 h-4 text-primary-foreground" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/></svg>
              </a>
              <a href="https://facebook.com/mysabbat.dk" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-primary-foreground/20 transition-colors" aria-label="Facebook">
                <svg className="w-4 h-4 text-primary-foreground" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
            </div>
            <a href="mailto:kontakt@mysabbat.dk" className="inline-flex items-center gap-2 text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">
              <Mail className="w-4 h-4" />
              kontakt@mysabbat.dk
            </a>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-primary-foreground/15">
        <div className="container py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-primary-foreground/60">
            <p>© {currentYear} MySabbat. Alle rettigheder forbeholdes.</p>
            <p className="flex items-center gap-1">
              Lavet med <Heart className="w-3.5 h-3.5 text-accent fill-accent" /> i Danmark
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
